export default __webpack_public_path__ + "static/media/QoS.e9385954.png";